import React, { Component } from "react";
import { SwipeableDrawer } from "@material-ui/core";
import { withRouter } from "react-router";
import DineSuperbContent from "./DineSuperbContent";

class DineSuperbDrawer extends Component {
  render() {
    const { drawerOpen, onClose, dineSuperbBranches } = this.props;
    return (
      <div className="w-100">
        <SwipeableDrawer
          anchor="bottom"
          open={drawerOpen}
          onClose={() => onClose()}
          PaperProps={{
            style: { minHeight: 225, height: "auto" },
            className: "text-center",
          }}
          onBackdropClick={() => onClose()}
        >
          <DineSuperbContent
            onClose={() => onClose()}
            dineSuperbBranches={dineSuperbBranches}
          />
        </SwipeableDrawer>
      </div>
    );
  }
}
export default withRouter(DineSuperbDrawer);
